import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import axios from 'axios';
import { CodeBlock } from '@cimpress/react-components';
import { useEffect, useState } from 'react';
import { getI18nInstance } from '../../../locales/i18n';
import { Spinner } from '@cimpress/react-components/lib/shapes';
import { DetailFieldVariant, DetailsField } from '../../components/detailsField';
import { BatonTransmissionDetails } from '../../common/batonTransmissionDetails';
export const ApiPollTransmissionDetails = ({ accessToken, transmissionDetails, language }) => {
    var _a, _b;
    const t = getI18nInstance().getFixedT(language);
    const [context, setContext] = useState({
        executionDetails: [],
        executionToShow: undefined,
        showMore: false,
        isLoading: false,
        showError: false,
        errorMessage: undefined
    });
    const getInitialData = async () => {
        if (legacyBatonsResult) {
            try {
                setContext(Object.assign(Object.assign({}, context), { isLoading: true }));
                const response = await axios.get(legacyBatonsResult.href, { headers: { Authorization: `Bearer ${accessToken}` } });
                const executionData = response === null || response === void 0 ? void 0 : response.data;
                const hydratedExecutionData = executionData.batons;
                const latestExecutionToShow = (hydratedExecutionData === null || hydratedExecutionData === void 0 ? void 0 : hydratedExecutionData.length) ? hydratedExecutionData[0] : undefined;
                setContext(Object.assign(Object.assign({}, context), { executionDetails: hydratedExecutionData, executionToShow: latestExecutionToShow, isLoading: false }));
            }
            catch (error) {
                setContext(Object.assign(Object.assign({}, context), { executionDetails: [], isLoading: false, showError: true, errorMessage: `${t('itemTransmission.apiPollTransmission.errorFetchingExecutionDetails')} : ${error.message}` }));
            }
        }
    };
    useEffect(() => {
        getInitialData();
    }, []);
    const legacyBatonsResult = (_a = transmissionDetails === null || transmissionDetails === void 0 ? void 0 : transmissionDetails._links) === null || _a === void 0 ? void 0 : _a.legacyBatons;
    if (!legacyBatonsResult) {
        if ((_b = transmissionDetails._embedded) === null || _b === void 0 ? void 0 : _b.transmissionExecutionDetails) {
            return _jsx(BatonTransmissionDetails, { language: language, transmissionDetails: transmissionDetails._embedded.transmissionExecutionDetails });
        }
        return _jsx(_Fragment, { children: "N/A" });
    }
    const getErrorDetails = error => {
        return _jsx(DetailsField, { label: t('itemTransmission.transmissionDetail.title'), value: error, variant: DetailFieldVariant.Danger });
    };
    const getCodeBlock = () => {
        const transmission = context.executionToShow;
        return (transmission
            && _jsxs(_Fragment, { children: [_jsx("a", Object.assign({ style: { cursor: 'pointer' }, onClick: () => {
                            setContext(Object.assign(Object.assign({}, context), { showMore: !context.showMore }));
                        } }, { children: context.showMore ? t('itemTransmission.hideJson') : t('itemTransmission.viewJson') })), _jsx("div", { children: context.showMore && _jsx(CodeBlock, { code: JSON.stringify(transmission, null, 2) }) })] }));
    };
    const executionSummary = (_jsxs(_Fragment, { children: [context.showError && getErrorDetails(context.errorMessage), (legacyBatonsResult && context.isLoading)
                ? _jsx(Spinner, {})
                : context.executionToShow
                    && _jsx(_Fragment, { children: _jsx("div", Object.assign({ style: { width: '82em', padding: '20px', overflow: 'hidden' } }, { children: _jsx("div", { children: getCodeBlock() }) })) })] }));
    return _jsx("div", Object.assign({ style: { display: 'flex' } }, { children: executionSummary }));
};
